import React, { useMemo } from 'react'
import moment from 'moment/moment'
import IconButton from '@material-ui/core/IconButton'
import { CancelOutlined } from '@material-ui/icons'

import PropTypes from 'prop-types'

import { StyledMutedButton } from '../Approvals/ApprovalView.styles'

const InvoiceExpertButtons = ({ onUpdateManyEntries, entry }) => {
  const onDefer = async entryToDefer => {
    let deferToMonth
    const isDefered = !!entryToDefer.deferToMonth

    if (isDefered) {
      const momentDefer = moment.utc(entryToDefer.deferToMonth)

      if (momentDefer.isSame(moment.utc(), 'month')) {
        deferToMonth = moment.utc().add(1, 'month')
      }

      if (momentDefer.isAfter(moment.utc(), 'month')) {
        deferToMonth = moment.utc()
      }
    } else deferToMonth = moment.utc().add(1, 'month')

    onUpdateManyEntries([
      {
        ...entryToDefer,
        deferToMonth: deferToMonth ? deferToMonth.toISOString() : null,
      },
    ])
  }

  const isDeferedToAnotherMonth = useMemo(() => {
    if (!entry.deferToMonth) return false
    const momentDefer = moment.utc(entry.deferToMonth)
    return momentDefer.isAfter(moment.utc(), 'month')
  }, [entry])

  return (
    <div style={{ gap: 4, display: 'flex' }}>
      {isDeferedToAnotherMonth && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '2px',
          }}
        >
          <IconButton onClick={() => onDefer(entry)}>
            <CancelOutlined />
          </IconButton>
          <span>Deferred to {moment.utc(entry.deferToMonth).format('MMMM - YYYY')}</span>
        </div>
      )}
      {!isDeferedToAnotherMonth && (
        <>
          <StyledMutedButton
            onClick={() => {
              onDefer(entry)
            }}
          >
            Defer
          </StyledMutedButton>
        </>
      )}
    </div>
  )
}

InvoiceExpertButtons.propTypes = {
  entry: PropTypes.object.isRequired,
  onUpdateManyEntries: PropTypes.func.isRequired,
}

export default InvoiceExpertButtons
